import React, {
  useEffect, useState, useMemo, useRef, useCallback,
} from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import './style.scss';
import { Button, Progress } from 'antd';
import {
  LoadingOutlined,
} from '@ant-design/icons';
import UnicommerceIntegrationActions from '@Actions/integrations/unicommerceIntegrationActions';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';

/**
 *
 */
const UnicommerceAccountSync = ({
  user, setStep, syncProducts, syncProductsLoading, unicommerceConnections, getUnicommerceConnections,
}) => {
  const [syncedPercentage, setSyncedPercentage] = useState(0);
  const [syncedProductStatus, setSyncedProductStatus] = useState(null);
  const [totalProducts, setTotalProducts] = useState(0);
  const [syncedProducts, setSyncedProducts] = useState(0);

  const useInterval = (callback, delay) => {
    useEffect(() => {
      const intervalId = setInterval(callback, delay);
      return () => clearInterval(intervalId);
    }, [callback, delay]);
  };

  useEffect(() => {
    if (unicommerceConnections.success) {
      setSyncedPercentage(unicommerceConnections?.data?.product_sync_progress_percentage);
      setSyncedProducts(unicommerceConnections?.data?.product_sync_progress_number);
      setTotalProducts(unicommerceConnections?.data?.total_products);
      setSyncedProductStatus(unicommerceConnections?.data?.product_sync_status);
    }
  }, [unicommerceConnections]);

  if (unicommerceConnections?.data?.product_sync_status !== 'SUCCESS' && unicommerceConnections?.data?.product_sync_status) {
    useInterval(() => {
      getUnicommerceConnections(user?.tenant_info?.org_id);
    }, 2000);
  }

  const handleSubmit = () => {
    const payload = {
      org_id: user?.tenant_info?.org_id,
    };
    syncProducts(payload, () => {
      getUnicommerceConnections(user?.tenant_info?.org_id);
    });
  };

  const getHeading = useMemo(() => {
    if (syncedProductStatus === 'IN_PROGRESS') { return 'We are syncing your products and vendors from Unicommerce to Procuzy. This will take 2-3 minutes to complete.'; }
    if (syncedProductStatus === 'SUCCESS') { return 'Your inventory is already synced in order to update your inventory you can sync again.'; }
    if (syncedProductStatus === 'FAILED') { return 'Your inventory sync is failed. Please retry to sync your unicommerce inventory.'; }

    return 'In order to get your products you need to sync your unicommerce inventory';
  }, [syncedProductStatus]);

  return (
    <div className="integration-step__wrapper">
      <div className="ant-row">
        <div className="ant-col-md-24">
          <div style={{ fontSize: '14px', marginBottom: '5px', marginTop: '10px' }}>
            {getHeading}
          </div>
        </div>
        <div className="ant-col-md-24" style={{ paddingTop: '15px' }}>
          {syncedProductStatus === 'IN_PROGRESS' ? (
            <div className="unicommerce__sync-progress__wrapper">
              <div className="unicommerce__sync-progress">
                <Progress
                  showInfo={false}
                  percent={syncedPercentage}
                  strokeWidth={14}
                />
                <div className="unicommerce__sync-progress-detail__wrapper">
                  <div className="unicommerce__sync-progress-detail">
                    {`Successfully synchronized ${syncedProducts} out of ${totalProducts} products.`}
                    &nbsp;
                    <LoadingOutlined />
                  </div>
                </div>
              </div>
              <div className="integration-step__footer" style={{ display: 'flex', paddingTop: '10px', paddingLeft: '15px' }}>
                <Button
                  type="primary"
                  ghost
                  onClick={() => setStep(2)}
                >
                  Back
                </Button>

                  &nbsp;&nbsp;
                  <Button
                    ghost
                    type="primary"
                    onClick={() => setStep(2)}
                  >
                    Review and Finish
                  </Button>
              </div>
            </div>
          )
            : (
              <div className="integration-step__footer" style={{ display: 'flex', paddingTop: '10px', paddingLeft: '15px' }}>
                <Button
                  type="primary"
                  ghost
                  onClick={() => setStep(2)}
                  disabled={syncProductsLoading}
                >
                  Back
                </Button>
                &nbsp;&nbsp;
                <Button
                  type="primary"
                  ghost
                  onClick={() => handleSubmit()}
                  loading={syncProductsLoading}
                  disabled={syncProductsLoading}
                >
                  {!syncedProductStatus ? 'Sync Inventory' : 'Re-Sync Inventory'}
                </Button>      
                &nbsp;&nbsp;
                {syncedProductStatus === 'SUCCESS' && (<Button
                  type="primary"
                  onClick={() => handleSubmit()}
                  loading={syncProductsLoading}
                  disabled={syncProductsLoading}
                >
                  Continue
                </Button>)}
              </div>
            )}
        </div>
      </div>

    </div>
  );
};

const mapStateToProps = ({ /* Import Reducers here */ UserReducers, UnicommerceIntegrationReducers }) => ({
  user: UserReducers.user,
  syncProductsLoading: UnicommerceIntegrationReducers.syncProductsLoading,
  unicommerceConnections: UnicommerceIntegrationReducers.unicommerceConnections,

});

const mapDispatchToProps = (/* Import actions here */ dispatch) => ({
  syncProducts: (payload, callback) => dispatch(UnicommerceIntegrationActions.syncProducts(payload, callback)),
  getUnicommerceConnections: (orgId, callback) => dispatch(UnicommerceIntegrationActions.getUnicommerceConnections(orgId, callback)),
});

UnicommerceAccountSync.propTypes = {
  user: PropTypes.any,
  syncProducts: PropTypes.func,
  syncProductsLoading: PropTypes.bool,
  setStep: PropTypes.func,
  unicommerceConnections: PropTypes.any,
  getUnicommerceConnections: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UnicommerceAccountSync));
